import React from "react"
import styled from "styled-components"
import { Button, FormField, FullScreenLoadingCover } from "@prosolve/common-components-ui"
import useForm from "../../hooks/useForm"
import useDataUserAccount from "../../dataHooks/useDataUserAccount"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  border: ${({theme}) => theme.borders.main};
  border-radius: ${({theme}) => theme.borderRadius.main};
`

const RowGroup = styled.div`
  display: flex;
  gap: 10px;
`

export default ({
  userAccount,
  onUpdate
}) => {
  const { name, firstName, lastName } = userAccount || {}

  const { isLoading, updateUserAccount } = useDataUserAccount()

  const formData = useForm({
    requiredFields: ['firstName', 'lastName'],
    optionalFields: [],
    initData: {
      name,
      firstName,
      lastName
    }
  })

  const handleClick = async () => {
    if (formData.isValid()) {
      const { firstName, lastName } = formData.values
      const data = {
        ...formData.values,
        name: `${firstName} ${lastName}`
      }
      await updateUserAccount(data)
      await onUpdate()
    }
  }

  return (
    <Container>
      <RowGroup>
        <FormField
          fieldId='firstName'
          type='text'
          label='First Name *'
          placeholder='Enter First Name'
          style={{ flex: 1 }}
          formData={formData}
        />
        <FormField
          fieldId='lastName'
          type='text'
          label='Last Name *'
          placeholder='Enter Last Name'
          style={{ flex: 1 }}
          formData={formData}
        />
      </RowGroup>
      <div style={{ width: '200px' }}>
        <Button $colored={true} onClick={handleClick}>
          Save
        </Button>
      </div>
      {isLoading &&
        <FullScreenLoadingCover />
      }
    </Container>
  )
}
